/**
 * Admin order_status transitions (docs/order-management-admin-guide.md).
 * API uses string statuses; payloads use `cancelled` (UK spelling per guide).
 */

const TRANSITIONS = {
  pending: ['confirmed', 'cancelled'],
  confirmed: ['processing', 'cancelled'],
  processing: ['shipped', 'cancelled'],
  shipped: ['delivered', 'cancelled', 'returned'],
  delivered: ['returned', 'refund_pending'],
  returned: ['refunded'],
  refund_pending: ['refunded', 'delivered'],
  refunded: [],
  cancelled: [],
};

/** Normalize legacy/alternate spellings to matrix keys. */
export function canonicalOrderStatusKey(status) {
  if (status == null || status === '') return '';
  const s = String(status).trim().toLowerCase();
  if (s === 'canceled') return 'cancelled';
  return s;
}

export function getAllowedNextOrderStatuses(currentStatus) {
  const key = canonicalOrderStatusKey(currentStatus);
  return TRANSITIONS[key] ? [...TRANSITIONS[key]] : [];
}

export const ALL_ORDER_STATUSES = [
  'pending',
  'confirmed',
  'processing',
  'shipped',
  'delivered',
  'cancelled',
  'returned',
  'refund_pending',
  'refunded',
];

export const PAYMENT_STATUSES = ['pending', 'paid', 'failed'];

export const REFUND_STATUSES = ['requested', 'approved', 'rejected', 'completed'];
